import { TEXTOS } from '../../lib/glossario'
import type { CommitNaTela } from '../../types/repositorios'

/** Quantos caminhos a coleta guarda por commit; acima disso o GitHub devolve mais do que se grava. */
export const TETO_DE_ARQUIVOS_POR_COMMIT = 200

/**
 * A sublinha com os arquivos que um commit alterou.
 *
 * A lista gravada é truncada em 200 caminhos; quando o commit alterou mais do que isso a tela diz,
 * em vez de deixar o fiscal contar e achar que faltou coleta.
 *
 * @param props o commit
 * @returns a lista de caminhos
 */
export function ArquivosDoCommit({ commit }: { commit: CommitNaTela }) {
  const t = TEXTOS.repositorios.commits
  const arquivos = commit.arquivos ?? []
  const total = commit.arquivosAlterados ?? arquivos.length
  const truncada = total > arquivos.length

  return (
    <div className="rounded-md bg-slate-50 px-3 py-2" role="region" aria-label={t.arquivosAlterados}>
      <p className="text-xs font-semibold text-slate-500">{t.arquivosAlterados}</p>
      {arquivos.length === 0 ? (
        <p className="mt-1 text-sm text-slate-600">{t.semArquivos}</p>
      ) : (
        <ul className="mt-1 space-y-0.5">
          {arquivos.map((caminho) => (
            <li key={caminho} className="break-all font-mono text-xs text-slate-800">
              {caminho}
            </li>
          ))}
        </ul>
      )}
      {truncada && <p className="mt-2 text-xs text-slate-600">{t.arquivosTruncados(total, arquivos.length)}</p>}
    </div>
  )
}
